<script setup>
const props = defineProps({
  variant: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'tight'].includes(value),
  },
});

const variantClasses = {
  default: 'tw-p-6 tw-gap-4',
  tight: 'tw-p-3 tw-gap-2',
};
</script>

<template>
  <div
    :class="[
      'tw-rounded-lg tw-flex tw-flex-col tw-justify-center tw-border',
      variantClasses[props.variant],
    ]"
  >
    <div class="tw-text-blue tw-text-4xl tw-font-medium tw-text-center">
      <slot name="stat" />
    </div>
    <div class="tw-flex tw-gap-1 tw-text-center tw-justify-center tw-text-grey-dark tw-items-center">
      <slot name="title" />
    </div>
  </div>
</template>
